import { Component, OnInit } from '@angular/core';
// eslint-disable-next-line td-wb-rules/uirouter-import-rule
import { StateService } from '@uirouter/core';

// eslint-disable-next-line td-wb-rules/change-detection-strategy-rule
@Component({
  selector: 'td-wb-old-agreements-modal',
  templateUrl: './old-agreements.modal.component.html',
  styleUrls: ['./old-agreements.modal.component.scss'],
  standalone: false
})
export class OldAgreementsModalComponent implements OnInit {
  agreementType: string;

  constructor(private stateService: StateService) {
  }

  ngOnInit(): void {
    this.agreementType = this.stateService.params.agreementType;
  }
}
